import React, { useState, useEffect } from 'react';
import { listenToShops, updateShop } from '../services/firebase';
import toast from 'react-hot-toast';

export default function Merchants() {
  const [shops, setShops] = useState([]);
  const [linkId, setLinkId] = useState('');
  const [selected, setSelected] = useState(null);

  useEffect(() => listenToShops(setShops), []);

  const pending = shops.filter((s) => !s.merchantId);
  const linked = shops.filter((s) => s.merchantId);

  const handleLink = async () => {
    if (!selected || !linkId.trim()) { toast.error('Paste merchant Firebase Auth UID'); return; }
    await updateShop(selected.id, { merchantId: linkId.trim() });
    toast.success('Merchant linked');
    setSelected(null);
    setLinkId('');
  };

  return (
    <div className="page-body">
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontFamily: 'Clash Display, sans-serif', fontSize: 24, fontWeight: 700, marginBottom: 4 }}>Merchant Onboarding</div>
        <div style={{ fontSize: 13, color: 'var(--text2)' }}>
          {pending.length} pending · {linked.length} linked
        </div>
      </div>

      {pending.length > 0 && (
        <div className="table-card" style={{ marginBottom: 20, border: '1px solid rgba(255,152,0,0.35)' }}>
          <div className="table-header">
            <div className="table-title">⚠️ Pending merchant link</div>
            <span className="badge badge-orange">{pending.length}</span>
          </div>
          <table>
            <thead><tr><th>SHOP</th><th>ADDRESS</th><th>STATUS</th><th>ACTION</th></tr></thead>
            <tbody>
              {pending.map((s) => (
                <tr key={s.id} style={{ background: 'rgba(255,152,0,0.04)' }}>
                  <td style={{ fontWeight: 600 }}>{s.emoji} {s.name}</td>
                  <td style={{ fontSize: 12, color: 'var(--text2)', maxWidth: 200 }}>{s.address || '—'}</td>
                  <td><span className={`badge ${s.active ? 'badge-green' : 'badge-gray'}`}>{s.active ? 'Active' : 'Inactive'}</span></td>
                  <td>
                    <button type="button" className="btn btn-green btn-sm" onClick={() => { setSelected(s); setLinkId(''); }}>Link merchant</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="table-card">
        <div className="table-header">
          <div className="table-title">Linked shops</div>
        </div>
        <table>
          <thead><tr><th>SHOP</th><th>MERCHANT ID</th><th>BANK / UPI</th><th>ACTIVE</th></tr></thead>
          <tbody>
            {linked.length === 0 ? (
              <tr><td colSpan={4} style={{ textAlign: 'center', color: 'var(--text2)', padding: 32 }}>No linked shops</td></tr>
            ) : linked.map((s) => (
              <tr key={s.id}>
                <td>{s.emoji} {s.name}</td>
                <td style={{ fontFamily: 'JetBrains Mono', fontSize: 11, color: 'var(--green)' }}>{s.merchantId}</td>
                <td style={{ fontSize: 12, color: 'var(--text2)', maxWidth: 220 }}>
                  {s.upiId ? (
                    <span>UPI: {s.upiId}</span>
                  ) : s.accountNumber ? (
                    <span>{s.bankName || 'Bank'} •••{String(s.accountNumber).slice(-4)}</span>
                  ) : (
                    <span style={{ color: 'var(--orange)' }}>Not provided</span>
                  )}
                </td>
                <td><span className={`badge ${s.active ? 'badge-green' : 'badge-gray'}`}>{s.active ? 'Active' : 'Inactive'}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {selected && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }} onClick={() => setSelected(null)}>
          <div className="card" style={{ maxWidth: 440, width: '100%', padding: 24 }} onClick={(e) => e.stopPropagation()}>
            <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 4 }}>Link merchant to {selected.name}</div>
            <div style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 16 }}>Paste the merchant&apos;s Firebase Auth UID from Authentication console.</div>
            <input placeholder="Merchant UID" value={linkId} onChange={(e) => setLinkId(e.target.value)} style={{ marginBottom: 12 }} />
            <div style={{ display: 'flex', gap: 8 }}>
              <button type="button" className="btn btn-green" onClick={handleLink}>Link</button>
              <button type="button" className="btn btn-ghost" onClick={() => setSelected(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
